import { countriesConfig, type Province } from './countriesConfig';

export const provinces: Record<string, readonly Province[]> = Object.fromEntries(
    Object.entries(countriesConfig).map(([countryISO2, countryConfig]) => [
        countryISO2,
        ('regions' in countryConfig ? countryConfig.regions : []).flatMap(region =>
            ('provinces' in region ? region.provinces : []).map<Province>(p => p)
        ),
    ])
);
